import React, { forwardRef, useRef, useImperativeHandle } from "react";
import styled from "styled-components";
import NextBtn from './next';
import { jumpTo } from '@/utils';

const Page3 = ({ data, onNext }, ref) => {

  const containerRef = useRef();

  useImperativeHandle(ref, () => {
    return {
      shareContainer() {
        return containerRef.current
      }
    }
  });

  const handleDetail = () => {
    jumpTo(`storm://app/userzone?userID=${data.mostZanUser.userId}&userName=${data.mostZanUser.nickname}`)
  }

  return (
    <Container className="page page1" ref={containerRef}>
      {!!data.zanCount && (
        <div className="data-wrap">
          <div className="user-data">2025这一年</div>
          <div className="user-data">
            你在社区一共送出了<span className="light-data">{data.zanCount}</span>个赞
          </div>
          <div className="user-data">
            超越了<span className="light-data">{data.zanX}%</span>的风云用户
          </div>
          {data.mostZanUser && data.mostZanUser.nickname && (
            <div className="user-data" onClick={handleDetail}>
              <span>你和</span>
              <span className="light-data">@{data.mostZanUser.nickname}</span>
              <span>互动最多</span>
            </div>
          )}
          <div className="user-data">你的每一次点赞，是对创作者最大的鼓励！</div>
          <img className="award-tip" src="https://file.wogoo.com/image/activity/active_205/award-tip@2x.png" alt="" />
        </div>
      )}
      {!data.zanCount && (
        <div className="data-wrap">
          <div className="user-data">2025年8月13日</div>
          <div className="user-data">大盘<span className="light-data">3683</span>点，突破24年<span className="light-data">“924行情”</span>高点</div>
          <div className="user-data">A股不知不觉已经开启慢牛行情</div>
        </div>
      )}

      <div className="data-bg">
        <img
          className="logo-img"
          src="https://file.wogoo.com/image/activity/active_205/page3-bg@2x.png"
          alt=""
        />
      </div>
      <div className="data-bg">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/bottom-arrow@2x.png" alt=""/>
      </div>
      <div className="page-logo">
        <img className="logo-img" src="https://file.wogoo.com/image/activity/active_205/page-logo@2x.png" alt=""/>
      </div>
      <NextBtn onClick={onNext} />
    </Container>
  );
};

const Container = styled.div``;

export default React.memo(forwardRef(Page3));



// WEBPACK FOOTER //
// ./src/views/activity_205/page3.js